import React, { Component } from "react";

export class Jumbotron extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="homeJumbotron jumbotron">
          <div className="homeJumbotron-content">
            <h1 className="heading-1">Marcus Mckinstry</h1>
            <h2 className="heading-2">Web Developer</h2>
            <ul className="homeIconList">
              <li>
                <a 
                  href="mailto: jinjoe@zoho.com"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <img src="assets/img/icon-email.png" alt=""/>
                </a>
              </li>
              <li>
                <a 
                  href="https://github.com/Jimmyelvis"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <img src="assets/img/icon-github.png" alt=""/>
                </a>
              </li>
              <li>
                <a 
                  href="https://www.linkedin.com/in/marcusmckinstry/"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <img src="assets/img/icon-linked.png" alt=""/>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Jumbotron;
